module.exports = __webpack_public_path__ + "static/img/info2.03fb442.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/info2.png
// module id = Yjaq
// module chunks = 24